"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
* Enum class EquipmentTypes.
* @enum {}
* @readonly
*/
var EquipmentTypes = /*#__PURE__*/function () {
  function EquipmentTypes() {
    _classCallCheck(this, EquipmentTypes);

    _defineProperty(this, "AUTO_CARRIER", "AUTO_CARRIER");

    _defineProperty(this, "AUTOHAULER", "AUTOHAULER");

    _defineProperty(this, "B_TRAIN", "B_TRAIN");

    _defineProperty(this, "BULK", "BULK");

    _defineProperty(this, "CONESTOGA", "CONESTOGA");

    _defineProperty(this, "CONTAINER", "CONTAINER");

    _defineProperty(this, "CONTAINER_BREAK_BULK", "CONTAINER_BREAK_BULK");

    _defineProperty(this, "CONTAINER_STANDARD_20_FOOT", "CONTAINER_STANDARD_20_FOOT");

    _defineProperty(this, "CONTAINER_STANDARD_40_FOOT", "CONTAINER_STANDARD_40_FOOT");

    _defineProperty(this, "CONTAINER_FLAT_TRACK_20_FOOT", "CONTAINER_FLAT_TRACK_20_FOOT");

    _defineProperty(this, "CONTAINER_FLAT_TRACK_40_FOOT", "CONTAINER_FLAT_TRACK_40_FOOT");

    _defineProperty(this, "CONTAINER_HEAVY_TESTED_20_FOOT", "CONTAINER_HEAVY_TESTED_20_FOOT");

    _defineProperty(this, "CONTAINER_HIGH_CUBE_40_FOOT", "CONTAINER_HIGH_CUBE_40_FOOT");

    _defineProperty(this, "CONTAINER_HIGH_CUBE_45_FOOT", "CONTAINER_HIGH_CUBE_45_FOOT");

    _defineProperty(this, "CONTAINER_INSULATED", "CONTAINER_INSULATED");

    _defineProperty(this, "CONTAINER_ISO_TANK_20_FOOT", "CONTAINER_ISO_TANK_20_FOOT");

    _defineProperty(this, "CONTAINER_ISO_TANK_24_FOOT", "CONTAINER_ISO_TANK_24_FOOT");

    _defineProperty(this, "CONTAINER_ISO_TANK_40_FOOT", "CONTAINER_ISO_TANK_40_FOOT");

    _defineProperty(this, "CONTAINER_OPEN_TOP_20_FOOT", "CONTAINER_OPEN_TOP_20_FOOT");

    _defineProperty(this, "CONTAINER_OPEN_TOP_40_FOOT", "CONTAINER_OPEN_TOP_40_FOOT");

    _defineProperty(this, "CONTAINER_REEFER_20_FOOT", "CONTAINER_REEFER_20_FOOT");

    _defineProperty(this, "CONTAINER_REEFER_40_FOOT", "CONTAINER_REEFER_40_FOOT");

    _defineProperty(this, "CONTAINER_REFRIGERATED", "CONTAINER_REFRIGERATED");

    _defineProperty(this, "CONVEYOR", "CONVEYOR");

    _defineProperty(this, "CURTAIN_SIDE", "CURTAIN_SIDE");

    _defineProperty(this, "DOUBLE_DROP", "DOUBLE_DROP");

    _defineProperty(this, "DROP_DECK", "DROP_DECK");

    _defineProperty(this, "DROP_DECK_LANDOLL", "DROP_DECK_LANDOLL");

    _defineProperty(this, "DRY_VAN", "DRY_VAN");

    _defineProperty(this, "DUMP_TRAILER", "DUMP_TRAILER");

    _defineProperty(this, "FLATBED", "FLATBED");

    _defineProperty(this, "FLATBED_53_FOOT", "FLATBED_53_FOOT");

    _defineProperty(this, "FLATBED_AIR_RIDE", "FLATBED_AIR_RIDE");

    _defineProperty(this, "FLATBED_CONESTOGA", "FLATBED_CONESTOGA");

    _defineProperty(this, "FLATBED_DOUBLE", "FLATBED_DOUBLE");

    _defineProperty(this, "FLATBED_HOTSHOT", "FLATBED_HOTSHOT");

    _defineProperty(this, "FLATBED_MAXI", "FLATBED_MAXI");

    _defineProperty(this, "FLATBED_OVERDIMENSION", "FLATBED_OVERDIMENSION");

    _defineProperty(this, "HOPPER", "HOPPER");

    _defineProperty(this, "HOPPER_BOTTOM", "HOPPER_BOTTOM");

    _defineProperty(this, "INSULATED_VAN", "INSULATED_VAN");

    _defineProperty(this, "LOWBOY", "LOWBOY");

    _defineProperty(this, "LOWBOY_OVERDIMENSION", "LOWBOY_OVERDIMENSION");

    _defineProperty(this, "MOVING_VAN", "MOVING_VAN");

    _defineProperty(this, "OTHER", "OTHER");

    _defineProperty(this, "PNEUMATIC", "PNEUMATIC");

    _defineProperty(this, "POWER_ONLY", "POWER_ONLY");

    _defineProperty(this, "REEFER", "REEFER");

    _defineProperty(this, "REEFER_AIR_RIDE", "REEFER_AIR_RIDE");

    _defineProperty(this, "REEFER_DOUBLE", "REEFER_DOUBLE");

    _defineProperty(this, "REEFER_INTERMODAL", "REEFER_INTERMODAL");

    _defineProperty(this, "REMOVABLE_GOOSENECK", "REMOVABLE_GOOSENECK");

    _defineProperty(this, "STEP_DECK", "STEP_DECK");

    _defineProperty(this, "STEPDECK_CONESTOGA", "STEPDECK_CONESTOGA");

    _defineProperty(this, "STRAIGHT_BOX_TRUCK", "STRAIGHT_BOX_TRUCK");

    _defineProperty(this, "STRETCH_TRAILER", "STRETCH_TRAILER");

    _defineProperty(this, "TANKER", "TANKER");

    _defineProperty(this, "TANKER_ALUMINUM", "TANKER_ALUMINUM");

    _defineProperty(this, "TANKER_INTERMODAL", "TANKER_INTERMODAL");

    _defineProperty(this, "TANKER_STEEL", "TANKER_STEEL");

    _defineProperty(this, "TILT", "TILT");

    _defineProperty(this, "TRUCK_AND_TRAILER", "TRUCK_AND_TRAILER");

    _defineProperty(this, "VAN_AIR_RIDE", "VAN_AIR_RIDE");

    _defineProperty(this, "VAN_DOUBLE", "VAN_DOUBLE");

    _defineProperty(this, "VAN_INSULATED", "VAN_INSULATED");

    _defineProperty(this, "VAN_INTERMODAL", "VAN_INTERMODAL");

    _defineProperty(this, "VAN_OPEN_TOP", "VAN_OPEN_TOP");

    _defineProperty(this, "VAN_ROLLER_BED", "VAN_ROLLER_BED");

    _defineProperty(this, "VAN_SPRINTER", "VAN_SPRINTER");

    _defineProperty(this, "VAN_TRIPLE", "VAN_TRIPLE");

    _defineProperty(this, "VAN_VENTED", "VAN_VENTED");

    _defineProperty(this, "VAN_WITH_CURTAINS", "VAN_WITH_CURTAINS");

    _defineProperty(this, "CONTAINER_53_FOOT", "CONTAINER_53_FOOT");
  }

  _createClass(EquipmentTypes, null, [{
    key: "constructFromObject",
    value:
    /**
    * Returns a <code>EquipmentTypes</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/EquipmentTypes} The enum <code>EquipmentTypes</code> value.
    */
    function constructFromObject(object) {
      return object;
    }
  }]);

  return EquipmentTypes;
}();

exports["default"] = EquipmentTypes;